import { SelectedFilters } from '@/components/FilterData/types';
import {
  normalizeSelectedFilters,
  normalizeSearchQuery,
  normalizePage,
  normalizePerPage,
} from '@/components/Search/utils';
import { api } from '@/services/api';
import { UUID } from '@/api/generatedApi';

export const CROSS_TENANT_METADATA_SEARCH_QUERY_KEY = 'crossTenant.metadataSearch';

export const queryKey = ({
  assetId,
  assetTenantId,
  searchTenantId,
  searchQuery,
  selectedFilters,
  page,
  perPage,
}: {
  assetId: UUID;
  assetTenantId: UUID;
  searchTenantId: UUID;
  searchQuery?: string;
  selectedFilters?: SelectedFilters;
  page?: string | number;
  perPage?: string | number;
}) => [
  CROSS_TENANT_METADATA_SEARCH_QUERY_KEY,
  {
    assetId,
    assetTenantId,
    searchTenantId,
    searchQuery: normalizeSearchQuery(searchQuery),
    selectedFilters: normalizeSelectedFilters(selectedFilters),
    page: normalizePage(page),
    perPage: normalizePerPage(perPage),
  },
];

export const queryFunction =
  ({
    assetId,
    assetTenantId,
    searchTenantId,
    searchQuery,
    selectedFilters,
    page,
    perPage,
  }: {
    assetId: UUID;
    assetTenantId: UUID;
    searchTenantId: UUID;
    searchQuery?: string;
    selectedFilters?: SelectedFilters;
    page?: string | number;
    perPage?: string | number;
  }) =>
  () =>
    api.crossTenant.crossTenantMetadataSearch({
      assetId,
      assetTenantId,
      searchTenantId,
      searchQuery: normalizeSearchQuery(searchQuery),
      filters: normalizeSelectedFilters(selectedFilters),
      page: normalizePage(page),
      perPage: normalizePerPage(perPage),
    });
